import React, {Component} from 'react';
import {Route} from "react-router-dom";
import {
  BidStatus,
  UpcomingBids,
  UpcomingBidDetails,
  ProjectStatus,
  TaskStatus,
  TaskDetails,
  ProjectRfiStatus,
  ProjectRfiDetails,
  SubmittalStatus,
  SubmittalDetails,
  PunchlistStatus,
  DailyLogDetails,
  MeetingMinutesDetails
} from "./ReportControllerFactory";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../Boilerplate/BreadcrumbContext";
import {RoutedTabsFactory} from "../Boilerplate/RoutedTabs";

const items = [
  {
    key: 'bid-status',
    selected: "/reports/bid-status",
    dest: () => "/reports/bid-status",
    renderOn: {path: '/'},
    text: "Bid Status"
  },
  {
    key: 'upcoming-bids',
    selected: "/reports/upcoming-bids",
    dest: () => "/reports/upcoming-bids",
    renderOn: {path: '/'},
    text: "Upcoming Bids"
  },
  {
    key: 'upcoming-bid-details',
    selected: "/reports/upcoming-bid-details",
    dest: () => "/reports/upcoming-bid-details",
    renderOn: {path: '/'},
    text: "Upcoming Bid Details"
  },
  {
    key: 'project-status',
    selected: "/reports/project-status",
    dest: () => "/reports/project-status",
    renderOn: {path: '/'},
    text: "Project Status"
  },
  {
    key: 'task-status',
    selected: "/reports/task-status",
    dest: () => "/reports/task-status",
    renderOn: {path: '/'},
    text: "Task Status"
  },
  {
    key: 'task-details',
    selected: "/reports/task-details",
    dest: () => "/reports/task-details",
    renderOn: {path: '/'},
    text: "Task Details"
  },
  {
    key: 'rfi-status',
    selected: "/reports/rfi-status",
    dest: () => "/reports/rfi-status",
    renderOn: {path: '/'},
    text: "RFI Status"
  },
  {
    key: 'rfi-details',
    selected: "/reports/rfi-details",
    dest: () => "/reports/rfi-details",
    renderOn: {path: '/'},
    text: "RFI Details"
  },
  {
    key: 'submittal-status',
    selected: "/reports/submittal-status",
    dest: () => "/reports/submittal-status",
    renderOn: {path: '/'},
    text: "Submittal Status"
  },
  {
    key: 'submittal-details',
    selected: "/reports/submittal-details",
    dest: () => "/reports/submittal-details",
    renderOn: {path: '/'},
    text: "Submittal Details"
  },
  {
    key: 'punchlist-status',
    selected: "/reports/punchlist-status",
    dest: () => "/reports/punchlist-status",
    renderOn: {path: '/'},
    text: "Punch List Status"
  },
  {
    key: 'daily-log-details',
    selected: "/reports/daily-log-details",
    dest: () => "/reports/daily-log-details",
    renderOn: {path: '/'},
    text: "Daily Logs"
  },
  {
    key: 'meeting-minutes-details',
    selected: "/reports/meeting-minutes-details",
    dest: () => "/reports/meeting-minutes-details",
    renderOn: {path: '/'},
    text: "Meeting Minutes"
  },
];

const ReportsNavBar = RoutedTabsFactory(items, 'bid-status', {className: 'subnav'});

class Reports extends Component {
  render() {
    return (
      <div id='reports'>
        <Helmet>
          <title>Reports</title>
        </Helmet>
        {/*<ReportsNavBar/>*/}
        <Route path="/reports/bid-status" component={BidStatus}/>
        <Route path="/reports/upcoming-bids" component={UpcomingBids}/>
        <Route path="/reports/upcoming-bid-details" component={UpcomingBidDetails}/>
        <Route path="/reports/project-status" component={ProjectStatus}/>
        <Route path="/reports/task-status" component={TaskStatus}/>
        <Route path="/reports/task-details" component={TaskDetails}/>
        <Route path="/reports/rfi-status" component={ProjectRfiStatus}/>
        <Route path="/reports/rfi-details" component={ProjectRfiDetails}/>
        <Route path="/reports/submittal-status" component={SubmittalStatus}/>
        <Route path="/reports/submittal-details" component={SubmittalDetails}/>
        <Route path="/reports/punchlist-status" component={PunchlistStatus}/>
        <Route path="/reports/daily-log-details" component={DailyLogDetails}/>
        <Route path="/reports/meeting-minutes-details" component={MeetingMinutesDetails}/>
      </div>
    );
  }
}

export default withBreadcrumb(
  {title: 'Reports', path: '/reports'},
  Reports
);



// WEBPACK FOOTER //
// ./src/components/Reports/Reports.js